import "isomorphic-fetch";

import { API_URL } from "../config";

class api {
  authHeaders() {
    const headers = {};
    const patientToken = sessionStorage.getItem("patientToken");
    const formToken = sessionStorage.getItem("formToken");
    const deviceId = sessionStorage.getItem("deviceId");
    const rememberMe = localStorage.getItem("rememberMe");

    if (patientToken) headers["Authorization"] = `JWT ${patientToken}`;
    if (formToken) headers["x-form-token"] = formToken;
    if (deviceId) headers["x-device-id"] = deviceId;
    if (rememberMe) headers["x-remember-me"] = rememberMe;

    return headers;
  }

  get(path) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json", ...this.authHeaders() },
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  put(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "PUT",
          credentials: "include",
          headers: { "Content-Type": "application/json", ...this.authHeaders() },
          body: typeof body === "string" ? body : JSON.stringify(body),
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  putFormData(path, formData) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "PUT",
          credentials: "include",
          headers: { ...this.authHeaders() },
          body: formData,
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  postFormData(path, formData) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: { ...this.authHeaders() },
          body: formData,
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  delete(path) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          credentials: "include",
          method: "DELETE",
          headers: { "Content-Type": "application/json", ...this.authHeaders() },
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  post(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json", ...this.authHeaders() },
          body: typeof body === "string" ? body : JSON.stringify(body),
        });

        if (response.status === 401) {
          const res = await response.json().catch(() => ({ code: "UNAUTHORIZED", message: "Unauthorized" }));
          return reject(res);
        }

        const res = await response.json();
        if (response.status !== 200) {
          return reject(res);
        }
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  download(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${API_URL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json", ...this.authHeaders() },
          body: typeof body === "string" ? body : JSON.stringify(body),
        });
        if (response.status === 401) {
          return reject({ code: "UNAUTHORIZED", message: "Unauthorized" });
        }

        if (response.status !== 200) {
          return reject(response);
        }
        resolve(response);
      } catch (e) {
        reject(e);
      }
    });
  }
}

const API = new api();
export default API;
